import { useEffect } from 'react';

/** Kill the document scrollbar while a fixed full-screen fleet page is open.
 *
 * High Risk / Fuel Report / etc. are `position: fixed; inset: 0` with their own
 * inner scroll panes. Without this, the shell behind them can still be taller
 * than the viewport (`min-height: 100vh` + content), so the browser draws a
 * full-height scrollbar that moves nothing the owner can see. */
export function useLockBodyScroll(lock = true): void {
  useEffect(() => {
    if (!lock) return;
    const html = document.documentElement;
    const { body } = document;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, [lock]);
}
